import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from '@/services/ApiService'
import InlineSvgComponent from 'vue-inline-svg'
import { i18n } from '@/config/i18n'
import { resolveLocaleFromQuery } from '@/config/i18n/resolveLocale'

const app = createApp(App)

app.use(i18n)

// Langue d'amorçage depuis l'URL (?lang=). Indispensable en mode iframe
// (?withHeader=false) : le sélecteur de langue vit dans le header, lequel n'est
// alors pas monté — sans ceci le ?lang= ne serait jamais lu et l'iframe
// resterait sur la locale par défaut (fr-FR).
const urlLocale = resolveLocaleFromQuery(new URLSearchParams(window.location.search).get('lang'))
if (urlLocale !== null) {
  i18n.global.locale.value = urlLocale
}
app.use(store)
app.use(router)
app.component('inline-svg', InlineSvgComponent)
ApiService.init(app)

app.mount('#app')
